/**
 * Who is behind this site, for the legal pages.
 *
 * One place rather than a sentence typed into three translation files,
 * because the day there IS a registered company these values change and the
 * text around them does not. Every legal page reads them from here.
 *
 * TODO before the domain gets any real traffic: fill `name`, `taxId` and
 * `address`. Spanish/EU data-protection law requires whoever decides what
 * happens to somebody's e-mail to be identifiable, and a contact address
 * alone only carries that while this is a waiting list and nothing else.
 * Until they are filled, the privacy page names no controller and says so
 * rather than inventing one -- see LegalDocumentPage's own identity block.
 */
export const LEGAL_ENTITY = {
  /** Registered company name, or the person's own full name if there is no company yet. */
  name: '',
  /** NIF / CIF / VAT number. */
  taxId: '',
  /** Registered address. */
  address: '',
  /** The one address a visitor can write to about their data. Required. */
  privacyEmail: 'privacidad@heavydutymachinery.com',
  /** Where the rows physically live, as a visitor would recognise it. */
  hostingProvider: 'Microsoft Azure (Unión Europea)',
};

/** True once somebody can tell from the page who is responsible. */
export const IS_LEGAL_ENTITY_IDENTIFIED = LEGAL_ENTITY.name.trim().length > 0;
